import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Hdr"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M22.5 11.25V8.25C22.5 7.42157 21.8284 6.75 21 6.75H16.5V17.25H18V12.75H19.11L20.865 17.25H22.5L20.7525 12.75H21C21.8284 12.75 22.5 12.0784 22.5 11.25ZM18 8.25H21V11.25H18V8.25ZM12 17.25H9V6.75H12C13.6569 6.75 15 8.09315 15 9.75V14.25C15 15.9069 13.6569 17.25 12 17.25ZM10.5 15.75H12C12.8284 15.75 13.5 15.0784 13.5 14.25V9.75C13.5 8.92157 12.8284 8.25 12 8.25H10.5V15.75ZM6 6.75V11.25H3V6.75H1.5V17.25H3V12.75H6V17.25H7.5V6.75H6Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Hdr.vue"]]);
